module.exports = __webpack_public_path__ + "img/pc-tob-code.c7872a92.jpeg";